import React, { Component } from 'react';
import "../App.css"
import "monday-ui-react-core/dist/main.css";
import AssetRequestHandle from "./AssetRequestHandle";
import HandleRequest from './Inventory/HandleRequest';
import { Button, Loader,Tab,Modal,ModalContent,TextField, Heading } from 'monday-ui-react-core';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import WorkOrderRequestHandle from './work-order/WorkOrderHandle';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import env from "react-dotenv";
let baseUrl = process.env.REACT_APP_SERVER_URL;

export default class RedirectRequest extends Component {
    constructor(props) {
        super(props)
        this.state = {
            redirectType: '',
            tabValue:'',
            userId:'',
            accountId:'',
            configurationValue:'',
            workSpaceId:'',
            isloading:true,
            modalClose:false
        }
    }

    async componentDidMount() {
        this.setState({
            isloading:true
        }) 
        
        // await axios.get(`${serverUrl}/fetch-configuration-assets`)
        await this.getUserId(baseUrl)
        await this.mondayListenProcess();
        this.setState({
            isloading:false
        })
    }

    getUserId=async(serverUrl)=>{
        try{
            let workSpaceBackend=""
            let getCurrentUser=""
            let getCurrentAccountId=""
            let assetIds=window.location.search;
            assetIds= assetIds.split('&')
            let regex = /assetId=(\d+)/;
            let accountIdRegex = /accountId=(\d+)/;
            let userIdRegex=/userId=(\d+)/;
            // Filter elements containing assetId and map to extract assetId
            let assetId = assetIds.filter(str => regex.test(str))
                            .map(str => str.match(regex)[1]);
            const userId = assetIds.find(p => p.includes("userId")).split("=")[1];
            const accountId = assetIds.find(p => p.includes("accountId")).split("=")[1];

            let assetIdParam={
                "assetId":assetId[0],
                "userId":userId,
                "accountId":accountId
            }
            await axios.get(`${serverUrl}/get-workSpaceId-external`,{params:assetIdParam})
            .then((res)=>{
                workSpaceBackend=res.data.workSpaceData.workSpaceId;
                getCurrentUser=res.data.workSpaceData.getCurrentUser;
                getCurrentAccountId=res.data.workSpaceData.getCurrentAccountId;
            })
            .catch((err)=>{
                return null
            })
            let workSpaceIdPass={
                "workSpaceId":workSpaceBackend,
                "userId":getCurrentUser,
                "accountId":getCurrentAccountId
            }
            await axios.get(`${serverUrl}/get-user-external`,{params:workSpaceIdPass})
            .then((res)=>{
                const getUserId=res.data.userId
                const workSpaceIds=res.data.workspaceId
                const getAccountId=res.data.accountId
                this.getConfigurationData(getUserId,serverUrl,workSpaceIds,getAccountId)
            }).catch((err)=>{
                return null
            })

        }catch(err){

        }
    }

    getConfigurationData=async(getUserId,serverUrl,workSpaceIds,getAccountId)=>{
        try{
            let param={
                userId:getUserId,
                workspaceId:workSpaceIds,
                accountId:getAccountId
            }
            await axios.get(`${serverUrl}/fetch-configuration-assets`,{params:param})
            .then((res)=>{
                const getConfigUserId=res.data.find(item=>item.userId)?.userId;
                if(getConfigUserId===getUserId){
                    const getConfigAsset=res.data;
                    const getConfigAssetValue=getConfigAsset[getConfigAsset.length-1].checkBoxValue
                    const workspcaeIds=getConfigAsset[getConfigAsset.length-1].workSpaceId
                    this.setState({
                        configurationValue:getConfigAssetValue,
                        workSpaceId:workspcaeIds,
                        userId:getUserId,
                        accountId:getAccountId
                    })
                    return;
                }
            })
            .catch((err)=>{
                return null
            })

        }catch(err){

        }
    }

    

    onClickTabValue=(event)=>{
        this.setState({
          tabValue:event,
          modalClose:true
        })
    }

    mondayListenProcess = async () => {
        let assetId = window.location.search
        assetId = assetId.split('&')
        if (assetId.length == 4) {
            let type = assetId[3].split('=')
            this.setState({ redirectType: type[1] })
        }
    }
    render() {
        const {  isloading, redirectType,tabValue,configurationValue,userId,workSpaceId,accountId } = this.state;
        return (
            <div style={{ width: "" }}>
                {isloading ?
                    <div className='loader'>
                        <Loader color="var(--primary-color)" hasBackground size={64} />
                    </div> :
                    <>
                        {

                            redirectType === "inventory"?
                                <div >
                                    <HandleRequest userId={userId} workSpaceId={workSpaceId} accountId={accountId}/>
                                </div> : null
                        }
                        {
                            (configurationValue === "Both"&&redirectType==="")||(configurationValue === "Both"&&redirectType===undefined) ?
                                <div>
                                    <CardGroup>
                                        <Card >
                                            <Card.Body>
                                                <Card.Text>
                                                    <Modal
                                                        id="story-book-modal"
                                                        onClose={false}
                                                        title="Choose your option"
                                                        triggerElement={null}
                                                        show={!this.state.modalClose}
                                                    >
                                                        <ModalContent>
                                                        <Row>
                                                            <Col xs={{ order: 12 }}><Button   style={{height:'50px',width:'100%'}} onClick={()=>this.onClickTabValue('requestReturn')}>Request and Return Form</Button></Col>
                                                            <br/>
                                                            <Col xs={{ order: 1 }}><Button   style={{height:'50px',width:'100%'}} onClick={()=>this.onClickTabValue('workOrder')}>Work Order</Button></Col>
                                                        </Row>                                                                                                                        
                                                        </ModalContent>
                                                    </Modal>
                                                </Card.Text>    
                                            </Card.Body>
                                        </Card>
                                        <Card style={{ width: '300px'}}>
                                            <Card.Body>
                                                <Card.Text>
                                                    {
                                                        tabValue==='requestReturn'&&(
                                                        <div>
                                                            <AssetRequestHandle userId={userId} workSpaceId={workSpaceId} accountId={accountId}/>
                                                        </div>
                                                        )
                                                    }
                                                    {
                                                        tabValue==='workOrder'&&(
                                                        <div style={{paddingLeft:'3px'}}>
                                                            <WorkOrderRequestHandle />
                                                        </div>
                                                        )
                                                    }
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </CardGroup>
                                </div>:null
                        }
                        {
                            (configurationValue === "requestAndReturn"&&(redirectType===""||redirectType===undefined))&&(
                                <div style={{width:'300px'}}>
                                    <AssetRequestHandle userId={userId} workSpaceId={workSpaceId} accountId={accountId}/>
                                </div>
                            )
                        }
                        {
                            (configurationValue === "workOrder"&&(redirectType===""||redirectType===undefined))&&(
                                <div>
                                    <WorkOrderRequestHandle />
                                </div>
                            )
                        }

                    </>}
            </div>
        )
    }
}